import Config from "./components/ClientConfig";

/**
 * Provider redirect origins are deployment-configured and are not exposed by
 * a proven frontend contract. Preserve that trust boundary while accepting
 * only absolute HTTPS (or same-machine development HTTP) and configured-base
 * relative paths. Protocol-relative URLs, credentials, and non-web schemes
 * fail closed before a URL reaches an iframe or window.open.
 */
export function toSafePaymentRedirectUrl(value) {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw || raw.startsWith("//")) return "";

  try {
    const configuredBase = new URL(
      `${String(Config.BASE_URL || "").replace(/\/+$/, "")}/`
    );
    const resolved = new URL(raw, configuredBase);
    const localDevelopmentHttp =
      resolved.protocol === "http:" &&
      ["localhost", "127.0.0.1", "[::1]"].includes(resolved.hostname);

    if (
      (resolved.protocol !== "https:" && !localDevelopmentHttp) ||
      resolved.username ||
      resolved.password
    ) {
      return "";
    }
    return resolved.href;
  } catch (error) {
    return "";
  }
}
